import React, { useState, useEffect } from "react";
import CustomAsyncDropdown from "../CustomAsyncDropdown.jsx";

/**
 * A wrapper for CustomAsyncDropdown that matches the common AsyncSelectDropdown API
 * used throughout the placement-ui project.
 */
const AsyncSelectDropdown = ({ 
  options = [], 
  value, 
  onChange, 
  placeholder, 
  isMulti = false, 
  loadOptions: loadOptionsProp,
  ...rest 
}) => {
  const [internalOptions, setInternalOptions] = useState(options);
  const [isLoading, setIsLoading] = useState(false);

  // Function to load options asynchronously if loadOptions is not provided
  const loadOptionsLocal = (inputValue) => {
    return new Promise((resolve) => {
      const filteredOptions = options.filter((option) => 
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      resolve(filteredOptions);
    });
  };

  // Sync internalOptions with options prop when it changes
  useEffect(() => {
    setInternalOptions(options);
  }, [options]);

  const handleInputChange = async (inputValue) => {
    // Call the external onInputChange if provided (useful for parent-managed search like infinite scroll)
    if (rest.onInputChange && typeof rest.onInputChange === "function") {
      rest.onInputChange(inputValue);
    }

    if (loadOptionsProp) {
      setIsLoading(true);
      try {
        const results = await loadOptionsProp(inputValue);
        // Handle both raw array and {options, hasNext} formats
        const nextOptions = Array.isArray(results) ? results : (results?.options || []);
        setInternalOptions(nextOptions);
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    } else {
      const filtered = await loadOptionsLocal(inputValue);
      setInternalOptions(filtered);
    }
  };

  return (
    <CustomAsyncDropdown
      options={internalOptions}
      value={value}
      onChange={onChange}
      placeholder={placeholder || "Select an option"}
      isMulti={isMulti}
      isLoading={isLoading}
      onInputChange={handleInputChange}
      isSearchable={true}
      {...rest}
    />
  );
};

export default AsyncSelectDropdown;
